import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmModels } from '..';

export function useGoogleSheetsFiles(enabled: boolean) {
  const { data, ...arg } = useQuery<{ files: crmModels.GoogleSheetsFileType[] }>(
    ['google-sheets-files'],
    async () => {
      const { data } = await $api.get('/v1/crm/drive/files');

      return { files: data?.data };
    },
    { enabled }
  );

  return { ...data, ...arg };
}
